import { Feature } from '@tencent/workbench';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ChartShapeProperty from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import {
    IChartFillFeature,
} from '@framework/workbench/drawer/ui/chart/global-settings/chart-fill/chart-fill-global-interface';
import { ChartFillFeature } from '@framework/workbench/drawer/ui/chart/common/fill/fill-feature';
import { IInputParams } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';

const DEFAULT_WHITE_COLOR = '#ffffff';
@Feature()
export class ChartGlobalFillFeature extends ChartFillFeature implements IChartFillFeature {
    public getModel() {
        this.getDrawerInputManager()?.updateCurrentModel(this.getAppService()
            .viewableServiceLayer.selectionService.getSelectedModel());
        return this.getDrawerInputManager()?.toUpateModel;
    }

    public getSelectModel(): any {
        const model = this.getModel() as IChartModel;
        if (model?.type === UIModelType.CHART) {
            const chartSpace = model.getChartSpaceProperty() as ChartShapeProperty;
            if (!chartSpace) return ;
            return chartSpace;
        }
        return ;
    }

    public getInputParams(): IInputParams {
        return {
            key: INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_FILL,
        };
    }
}

